import { Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationDto } from 'src/app/models/organization.dto';
import {
  ProcessElementDto,
  ProcessElementType
} from 'src/app/models/process/process-element-dto';
import { SearchListConfig } from 'src/app/models/search-list-config';
import { OrganizationSearchComponent } from '../../../../features/organization-search/organization-search.component';
import { RulePropertyEditEvent } from '../../model/rule-property-edit-event';
import { NOTIFICATIONS_SETUP_PROCESS_IDS_MODAL_DATA } from './notifications-setup-process-ids-modal.modal';

@Component({
  templateUrl: './notifications-setup-process-ids-modal.component.html',
  styleUrl: './notifications-setup-process-ids-modal.component.scss',
  imports: [OrganizationSearchComponent]
})
export class NotificationsSetupProcessIdsModalComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  protected readonly inputData = inject(
    NOTIFICATIONS_SETUP_PROCESS_IDS_MODAL_DATA
  );

  protected processNodes: ProcessElementDto[];
  protected organizationData: OrganizationDto[];
  protected config: SearchListConfig;

  constructor() {
    this.config = new SearchListConfig();
    this.config.virtual = true;
    this.config.placeholder = 'Filter here by processes';
    this.config.label = 'Processes';
    this.config.key = 'configurationElements';
    this.config.valueField = 'id';
    this.config.tagField = 'name';
    this.config.mode = 'hierarchy';
  }

  ngOnInit(): void {
    this.processNodes = [...this.inputData.processNodes];
    this.organizationData = this.toOrganizations(this.processNodes);
  }

  save(): void {
    const event = new RulePropertyEditEvent<ProcessElementDto[]>();
    event.notificationRuleId = this.inputData.notificationRuleId;
    event.value = this.toProcessElements(this.config.data);
    this.activeModal.close({
      saveAction: event
    });
  }

  close(): void {
    this.activeModal.dismiss();
  }

  changeFilter(organizations: OrganizationDto[]): void {
    this.config.data = organizations;
  }

  private toProcessElements(
    organizations: OrganizationDto[]
  ): ProcessElementDto[] {
    const result: ProcessElementDto[] = [];
    for (const organization of organizations) {
      let processNode: ProcessElementDto = null;
      if (organization.level == 3) {
        // Task
        const id = `${organization.id}`;
        const tokens = id.split('-');
        processNode = new ProcessElementDto();
        processNode.name = organization.name;
        processNode.id = Number.parseInt(tokens[3]);
        processNode.type = ProcessElementType.Task;
        processNode.compositeId = `${tokens[0]}-${tokens[1]}-${tokens[3]}`;
      } else if (organization.level == 2) {
        // Activity
        const id = `${organization.id}`;
        const tokens = id.split('-');
        processNode = new ProcessElementDto();
        processNode.name = organization.name;
        processNode.id = Number.parseInt(tokens[1]);
        processNode.type = ProcessElementType.Activity;
        processNode.compositeId = `${tokens[0]}-${tokens[1]}`;
      } else if (organization.level == 1) {
        // Process
        const id = `${organization.id}`;
        processNode = new ProcessElementDto();
        processNode.name = organization.name;
        processNode.id = Number.parseInt(id);
        processNode.type = ProcessElementType.Process;
        processNode.compositeId = id;
      }
      if (processNode) {
        result.push(processNode);
      }
    }
    return result;
  }

  private toOrganizations(
    processNodes: ProcessElementDto[]
  ): OrganizationDto[] {
    const result: OrganizationDto[] = [];
    for (const processNode of processNodes) {
      let organization: OrganizationDto = null;
      if (processNode.type == ProcessElementType.Task) {
        const tokens = processNode.compositeId.split('-');
        organization = new OrganizationDto();
        organization.id = `${tokens[0]}-${tokens[1]}-0-${tokens[2]}-1` as any;
        organization.level = 3;
        organization.name = processNode.name;
      } else if (processNode.type == ProcessElementType.Activity) {
        const tokens = processNode.compositeId.split('-');
        organization = new OrganizationDto();
        organization.id = `${tokens[0]}-${tokens[1]}-0` as any;
        organization.level = 2;
        organization.name = processNode.name;
      } else if (processNode.type == ProcessElementType.Process) {
        organization = new OrganizationDto();
        organization.id = processNode.compositeId as any;
        organization.level = 1;
        organization.name = processNode.name;
      }
      if (organization) {
        result.push(organization);
      }
    }
    return result;
  }
}
